import { getMetricFromPodiumLevels as r } from "../index5.js";
import { getLevelNetFacadeArea as t } from "../level-metrics/index24.js";
const a = (e) => r(e, t);
export {
  a as getPodiumNetFacadeArea
};
//# sourceMappingURL=index44.js.map
